<template>
  <div class="summary-mobile">
    <side-bar-promo
      v-if="!isDeletedAll"
      class="summary-mobile__promo"
      :class="{ '_show-mnogo-ru': showMnogoRuCard }"
      @changePromoCode="handlerChangedPromoCode"
      @showMnogoRuCard="handlerShowMnogoRuCard"
    />
    <basket-summary
      class="summary-mobile__summary"
      :amount="amount"
      :discount-amount="discountAmount"
      :quantity="quantity"
      :weight="weight"
      :cashback="cashback"
      :is-deleted-all="isDeletedAll"
    />
    <div v-if="showPayBonuses" class="summary-mobile__bonus-pay">
      Вы также можете использовать
      <b class="nobr">{{ maxPayBonusesFormatted }}</b>
      с личного счета на этапе оплаты
    </div>
    <cheapest-deliveries :cheapest-deliveries="cheapestDeliveries" />
    <loader-block v-if="isLoading" text="" class="summary-mobile__loader" />
  </div>
</template>

<script>
import { defineComponent } from '@vue/composition-api';
import { LoaderBlock } from '@book24/ui-components';

import { AMOUNT_DEFAULT_VALUE, DISCOUNT_AMOUNT_DEFAULT_VALUE } from '@/compositions/basket/basketStorage';

import useBasketSummary from '@/compositions/useBasketSummary';

import BasketSummary from '@/components/BasketSummary/index.vue';
import SideBarPromo from '@/components/SideBarPromo/index.vue';
import CheapestDeliveries from '@/components/_mobile/CheapestDeliveries/index.vue';

export default defineComponent({
  name: 'SideBarSummary',
  components: {
    LoaderBlock,
    BasketSummary,
    SideBarPromo,
    CheapestDeliveries,
  },
  props: {
    cashback: { type: Number, default: 0 },
    quantity: { type: Number, default: 0 },
    weight: { type: Number, default: 0 },
    maxPayBonuses: { type: [Number, String], default: 0 },
    amount: { type: Object, default: () => ({ ...AMOUNT_DEFAULT_VALUE }) },
    discountAmount: { type: Object, default: () => ({ ...DISCOUNT_AMOUNT_DEFAULT_VALUE }) },
    isLoading: { type: Boolean, default: false },
    cheapestDeliveries: { type: Array, default: () => ([]) },
    isDeletedAll: { type: Boolean, default: false },
  },
  setup(props) {
    const basketSummary = useBasketSummary(props);
    return { ...basketSummary };
  },
});
</script>

<style lang="less">
.summary-mobile {
  position: relative;

  &__loader {
    z-index: 2;
  }

  &__summary {
    background-color: @blue-back;
    padding: @size-x4;
  }

  &__promo {
    padding: @size-x6 @size-x4 @size-x3;

    &._show-mnogo-ru {
      padding-bottom: 0;
    }
  }

  &__bonus-pay {
    .small();

    padding: @size-x2 @size-x4 @main-size;
  }
}
</style>
